<script>
  import {Doughnut} from 'vue-chartjs'
  import VueCharts from 'vue-chartjs'


  export default {
    extends: Doughnut,
    mixins: [VueCharts.mixins.reactiveProp],
    prop: ['chartData'],
    data: () => ({
      options: {
        animation: {
          animateRotate: true,
          animateScale: true,

        },
        legend: {
          display: true,
          position: 'right',
          usePointStyle: true,
          fontSize: 5
        },
        legendCallback: function (chart) {
          var text = [];
          text.push('<ul class="' + chart.id + '-legend">');
          for (var i = 0; i < chart.data.datasets[0].data.length; i++) {
            text.push('<li><span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '">');
            if (chart.data.labels[i]) {
              text.push(chart.data.labels[i]);
            }
            text.push('</span></li>');
          }
          text.push('</ul>');
          return text.join("");
        },
        drawBorder: false,
        cutoutPercentage: 60,
        tooltips: {
          custom: function (tooltip) {
            //tooltip.x = 0;
            //tooltip.y = 0;
          },
          mode: 'single',
          callbacks: {
            label: function (tooltipItems, data) {
              var sum = data.datasets[0].data.reduce(add, 0);

              function add(a, b) {
                return a + b;
              }

              return parseInt((data.datasets[0].data[tooltipItems.index] / sum * 100), 10) + ' %';
            },
            beforeLabel: function (tooltipItems, data) {
              return data.datasets[0].data[tooltipItems.index] + ' leads';
            }
          }
        },
        responsive: false
      }
    }),
    mounted() {
      // Overwriting base render method with actual data.
      this.renderChart(this.chartData, this.options);
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/a_generalDashboard/Card5.vue